import { render, staticRenderFns } from "./BeneficiariesPanel.vue?vue&type=template&id=2deab383&scoped=true&"
import script from "./BeneficiariesPanel.vue?vue&type=script&lang=ts&"
export * from "./BeneficiariesPanel.vue?vue&type=script&lang=ts&"
import style0 from "./BeneficiariesPanel.vue?vue&type=style&index=0&id=2deab383&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2deab383",
  null
  
)

export default component.exports